<template>
    <tr v-if="hasFilterRow">
        <th v-if="lineNumbers"></th>
        <th v-if="selectable"></th>
        <th v-if="expandable && !allowExpandingAll"></th>
        <th
            v-if="expandable && allowExpandingAll"
            class="vgt-checkbox-col"
            style="padding-right: 0; padding-left: 0; border-right: unset;"
            v-on:click.stop="toggleExpandedAll"
        >
            <v-btn
                style="margin: 0; margin-top: -5px; margin-bottom: -7px; color: gray;"
                small
                icon
            >
                <v-icon>{{
                    allExpended
                        ? "mdi-minus-circle-outline"
                        : "mdi-plus-circle-outline"
                }}</v-icon>
            </v-btn>
        </th>
        <th
            class="filter-th"
            v-for="(column, index) in columns"
            :key="index"
            v-if="!column.hidden"
        >
            <div v-if="isFilterable(column)">
                <div
                    v-if="
                        !isDropdown(column) &&
                            !['date', 'decimal'].includes(column.type)
                    "
                    class="vgt-input-group"
                >
                    <v-menu :close-on-content-click="true" offset-y>
                        <template v-slot:activator="{ on }">
                            <button
                                v-on="on"
                                class="px-2"
                                style="background-color: #fff; white-space: nowrap; text-align: center;"
                            >
                                {{ getFilterType(column) }}
                            </button>
                            <!-- <v-btn style="" color="#FFF" small v-on="on"
                                ><v-icon>{{
                                    getFilterType(column)
                                }}</v-icon></v-btn
                            > -->
                            <!--  <v-icon v-on="on" class="pl-1">mdi-magnify</v-icon> -->
                        </template>
                        <v-card>
                            <v-list>
                                <v-list-tile
                                    style=""
                                    v-for="filterType in ['IS', 'IS NOT']"
                                    @click="setFilterType(column, filterType)"
                                >
                                    <v-list-tile-title>{{
                                        filterType
                                    }}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-card>
                    </v-menu>
                    <input
                        type="text"
                        class="vgt-input"
                        :placeholder="getPlaceholder(column)"
                        :value="columnFilters[column.field]"
                        @keyup.enter="
                            updateFiltersOnEnter(column, $event.target.value)
                        "
                        @input="
                            updateFiltersOnKeyup(column, $event.target.value)
                        "
                    />
                </div>
                <div class="vgt-input-group" v-if="column.type == 'decimal'">
                    <input
                        style="max-width: 75px;"
                        type="number"
                        class="vgt-input"
                        placeholder="Min"
                        v-bind:max="+columnFilters[column.field + '.max']"
                        :value="columnFilters[column.field + '.min']"
                        @keyup.enter="
                            updateFiltersOnEnter(
                                column,
                                $event.target.value,
                                'min'
                            )
                        "
                        @input="
                            updateFiltersOnKeyup(
                                column,
                                $event.target.value,
                                'min'
                            )
                        "
                    />
                    <input
                        style="max-width: 75px;"
                        type="number"
                        class="vgt-input"
                        placeholder="Max"
                        v-bind:min="+columnFilters[column.field + '.min']"
                        :value="columnFilters[column.field + '.max']"
                        @keyup.enter="
                            updateFiltersOnEnter(
                                column,
                                $event.target.value,
                                'max'
                            )
                        "
                        @input="
                            updateFiltersOnKeyup(
                                column,
                                $event.target.value,
                                'max'
                            )
                        "
                    />
                </div>
                <div
                    class="vgt-input-group reset-button-color"
                    v-if="column.type == 'date'"
                >
                    <v-menu
                        class="reset-button-color"
                        style="width: 100px; min-width: 100px;"
                        v-model="menus[column.field + 'FromMenu']"
                        :close-on-content-click="false"
                    >
                        <input
                            slot="activator"
                            class="vgt-input"
                            prepend-icon="mdi-calendar"
                            placeholder="From"
                            :value="
                                formatedDate(
                                    columnFilters[column.field + '.from']
                                )
                            "
                        />
                        <v-date-picker
                            class="reset-button-color"
                            v-model="columnFilters[column.field + '.from']"
                            :max="columnFilters[column.field + '.to']"
                            @change="() => closeMenu(column.field + 'FromMenu')"
                            @input="
                                updateFiltersOnKeyup(
                                    column,
                                    columnFilters[column.field + '.from'],
                                    'from'
                                )
                            "
                        ></v-date-picker>
                    </v-menu>
                    <v-menu
                        class="reset-button-color"
                        style="width: 100px; min-width: 100px;"
                        v-model="menus[column.field + 'ToMenu']"
                        :close-on-content-click="false"
                    >
                        <input
                            slot="activator"
                            class="vgt-input"
                            prepend-icon="mdi-calendar"
                            placeholder="To"
                            :value="
                                formatedDate(
                                    columnFilters[column.field + '.to']
                                )
                            "
                        />
                        <v-date-picker
                            class="reset-button-color"
                            v-model="columnFilters[column.field + '.to']"
                            :min="columnFilters[column.field + '.from']"
                            @change="() => closeMenu(column.field + 'ToMenu')"
                            @input="
                                updateFiltersOnKeyup(
                                    column,
                                    columnFilters[column.field + '.to'],
                                    'to'
                                )
                            "
                        ></v-date-picker>
                    </v-menu>
                    <v-btn
                        style="margin: 0; margin-top: -5px; margin-bottom: -7px; color: gray;"
                        small
                        icon
                        @click="clearDateFilter(column)"
                    >
                        <v-icon>mdi-close-circle</v-icon>
                    </v-btn>
                </div>
                <!-- options are a list of primitives -->
                <select
                    v-if="isDropdownArray(column)"
                    class="vgt-select"
                    :value="columnFilters[column.field]"
                    @change="updateFilters(column, $event.target.value)"
                >
                    <option value key="-1">{{ getPlaceholder(column) }}</option>
                    <option
                        v-for="(option, i) in column.filterOptions
                            .filterDropdownItems"
                        :key="i"
                        :value="option"
                        >{{ option }}</option
                    >
                </select>

                <!-- options are a list of objects with text and value -->
                <select
                    v-if="isDropdownObjects(column)"
                    class="vgt-select"
                    :value="columnFilters[column.field]"
                    @change="updateFilters(column, $event.target.value)"
                >
                    <option value key="-1">{{ getPlaceholder(column) }}</option>
                    <option
                        v-for="(option, i) in column.filterOptions
                            .filterDropdownItems"
                        :key="i"
                        :value="option.value"
                        >{{ option.text }}</option
                    >
                </select>
            </div>
        </th>
    </tr>
</template>

<script>
import isEqual from "lodash.isequal";
import moment from "moment";

export default {
    name: "VgtFilterRow",
    props: [
        "lineNumbers",
        "columns",
        "typedColumns",
        "globalSearchEnabled",
        "selectable",
        "expandable",
        "allExpended",
        "toggleExpandedAll",
        "allowExpandingAll",
        "mode",
        "url"
    ],
    watch: {
        columns: {
            handler(newValue, oldValue) {
                if (!isEqual(newValue, oldValue)) {
                    this.populateInitialFilters();
                }
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            columnFilters: {},
            columnFilterTypes: {},
            defaults: [],
            menus: {},
            timer: null
        };
    },
    computed: {
        // to create a filter row, we need to
        // make sure that there is atleast 1 column
        // that requires filtering
        hasFilterRow() {
            // if (this.mode === 'remote' || !this.globalSearchEnabled) {
            for (let i = 0; i < this.columns.length; i++) {
                const col = this.columns[i];
                if (col.filterOptions && col.filterOptions.enabled) {
                    return true;
                }
            }
            // }
            return false;
        }
    },
    methods: {
        reset(emitEvent = false) {
            this.columnFilters = {};
            this.columnFilterTypes = {};
            if (emitEvent) {
                this.$emit("filter-changed", {
                    columnFilters: this.columnFilters,
                    columnFilterTypes: this.columnFilterTypes
                });
            }
        },

        isFilterable(column) {
            return column.filterOptions && column.filterOptions.enabled;
        },

        isDropdown(column) {
            return (
                this.isFilterable(column) &&
                column.filterOptions.filterDropdownItems &&
                column.filterOptions.filterDropdownItems.length
            );
        },

        isDropdownObjects(column) {
            return (
                this.isDropdown(column) &&
                typeof column.filterOptions.filterDropdownItems[0] === "object"
            );
        },

        isDropdownArray(column) {
            return (
                this.isDropdown(column) &&
                typeof column.filterOptions.filterDropdownItems[0] !== "object"
            );
        },

        // get column's defined placeholder or default one
        getPlaceholder(column) {
            let placeholder =
                this.isFilterable(column) && column.filterOptions.placeholder;

            if (!placeholder) {
                placeholder =
                    column.filterOptions.filterDropdownItems &&
                    column.filterOptions.filterDropdownItems.length
                        ? `Select ${column.label}`
                        : `Search ${column.label}..`;
            }

            return placeholder;
        },

        updateFiltersOnEnter(column, value, prefix = null) {
            if (this.timer) clearTimeout(this.timer);
            this.updateFiltersImmediately(column, value, prefix);
        },

        updateFiltersOnKeyup(column, value, prefix = null) {
            // if the trigger is enter, we don't filter on keyup
            if (column.filterOptions.trigger === "enter") return;

            this.updateFilters(column, value, prefix);
        },

        // since vue doesn't detect property addition and deletion, we
        // need to create helper function to set property etc
        updateFilters(column, value, prefix) {
            if (this.timer) clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.updateFiltersImmediately(column, value, prefix);
            }, 400);
        },

        updateFiltersImmediately(column, value, prefix) {
            const field = prefix ? column.field + "." + prefix : column.field;

            const searchValue = column.searchValue
                ? column.searchValue(value)
                : value;

            this.$set(this.columnFilters, field, searchValue);
            this.$emit("filter-changed", {
                columnFilters: this.columnFilters,
                columnFilterTypes: this.columnFilterTypes
            });
        },

        populateInitialFilters() {
            this.saveDefaults();

            if (this.loadSavedFilters()) return;

            for (
                let i = 0;
                i < this.columns.filter(c => !c.isIcon).length;
                i++
            ) {
                const col = this.columns[i];
                // lets see if there are initial
                // filters supplied by user
                if (this.hasColumnFilter(col)) {
                    const fields = this.getFilterField(col);

                    fields.forEach(field => {
                        const value = this.getFilterValue(col, field);

                        if (
                            !this.isDropdown(col) &&
                            !["date", "decimal"].includes(col.type)
                        ) {
                            this.$set(this.columnFilterTypes, field, "IS");
                        }

                        this.$set(this.columnFilters, field, value);
                        // this.updateFilters(col, col.filterOptions.filterValue);
                        this.$set(col.filterOptions, "filterValue", undefined);
                    });
                }
            }
            //* lets emit event once all filters are set
            this.$emit("filter-changed", {
                columnFilters: this.columnFilters,
                columnFilterTypes: this.columnFilterTypes,
                isFirstTime: true
            });
        },
        saveDefaults() {
            this.columns
                .filter(c => c.filterOptions && c.filterOptions.enabled)
                .forEach(column => {
                    if (this.hasColumnFilter(column)) {
                        const fields = this.getFilterField(column);

                        fields.forEach(field => {
                            const value = this.getFilterValue(column, field);

                            this.defaults.push({ field, value });
                        });
                    }
                });
        },
        loadSavedFilters() {
            const table = this.$store.state.app.dataTables.find(
                t => t.url == this.url
            );

            if (!table || Object.keys(table.filters).length === 0) return;

            this.columnFilters = table.filters;
            this.columnFilterTypes = table.filterTypes;

            this.columns
                .filter(c => !c.isIcon)
                .forEach(column => {
                    this.$set(column.filterOptions, "filterValue", undefined);
                });

            this.$emit("filter-changed", {
                columnFilters: this.columnFilters,
                columnFilterTypes: this.columnFilterTypes,
                isFirstTime: true
            });

            return true;
        },
        restoreDefaults() {
            Object.keys(this.columnFilters).forEach(key => {
                const saved = this.defaults.find(d => d.field == key);

                if (!saved) {
                    this.columnFilters[key] = "";

                    return;
                }

                this.columnFilters[key] = saved.value;
            });

            this.$emit("filter-changed", {
                columnFilters: this.columnFilters,
                columnFilterTypes: this.columnFilterTypes
            });
        },
        hasColumnFilter(col) {
            if (this.isFilterable(col) && col.type == "date") {
                return (
                    col.filterOptions.filterValue ||
                    col.filterOptions.startDate ||
                    col.filterOptions.endDate
                );
            }

            return (
                this.isFilterable(col) &&
                typeof col.filterOptions.filterValue !== "undefined" &&
                col.filterOptions.filterValue !== null
            );
        },
        getFilterField(col) {
            if (col.type != "date") return [col.field];

            const filterValue = col.filterOptions.filterValue;

            if (col.filterOptions.filterValue) {
                return [
                    col.field +
                        "." +
                        filterValue.substring(0, filterValue.indexOf(":"))
                ];
            }

            const fields = [];

            if (col.filterOptions.startDate) {
                fields.push(col.field + ".from");
            }

            if (col.filterOptions.endDate) {
                fields.push(col.field + ".to");
            }

            return fields;
        },
        getFilterValue(col, field) {
            if (col.filterOptions && col.filterOptions.filterDropdownItems) {
                return this.getDropdownOptionValue(col);
            }

            if (col.type != "date") {
                return col.searchValue
                    ? col.searchValue(col.filterOptions.filterValue)
                    : col.filterOptions.filterValue;
            }

            const date = this.getDateValue(col, field);

            return date
                ? new Date(date).toISOString().substr(0, 10)
                : undefined;
        },
        getDateValue(col, field) {
            const filterValue = col.filterOptions.filterValue;

            //This will be removed eventually
            if (filterValue) {
                return filterValue.substring(filterValue.indexOf(":") + 1);
            }

            return field.endsWith("from")
                ? col.filterOptions.startDate
                : col.filterOptions.endDate;
        },
        getDropdownOptionValue(column) {
            if (this.isDropdownObjects(column)) {
                const value = column.filterOptions.filterDropdownItems.find(
                    o => o.text == column.filterOptions.filterValue
                ).value;

                return column.searchValue ? column.searchValue(value) : value;
            }

            return column.searchValue
                ? column.searchValue(column.filterOptions.filterValue)
                : column.filterOptions.filterValue;
        },
        formatedDate(date) {
            return date ? moment(date).format("L") : "";
        },
        closeMenu(menu) {
            this.menus[menu] = false;
        },
        clearDateFilter(column) {
            Object.keys(this.columnFilters)
                .filter(c => column.field == c.split(".")[0])
                .forEach(filter => {
                    this.$set(this.columnFilters, filter, undefined);

                    this.$set(column.filterOptions, "filterValue", undefined);

                    this.$emit("filter-changed", {
                        columnFilters: this.columnFilters,
                        columnFilterTypes: this.columnFilterTypes
                    });
                });
        },
        getActiveFilters() {
            return Object.keys(this.columnFilters).filter(key => {
                return this.columnFilters[key];
            });
        },
        isUsingDefaultFilters() {
            if (this.defaults.length != this.getActiveFilters().length)
                return false;

            if (
                this.defaults
                    .map(d => d.field)
                    .sort()
                    .join(",") !==
                this.getActiveFilters()
                    .sort()
                    .join(",")
            )
                return false;

            return this.getActiveFilters().every(filter => {
                const defaultValue = this.defaults.find(d => d.field == filter)
                    .value;

                return this.columnFilters[filter] == defaultValue;
            });
        },
        setFilterType(column, type) {
            this.columnFilterTypes[column.field] = type;

            this.updateFiltersOnKeyup(column, this.columnFilters[column.field]);
        },
        getFilterType(column) {
            return this.columnFilterTypes[column.field]
                ? this.columnFilterTypes[column.field]
                : "IS";
        }
    },
    mounted() {}
};
</script>

<style>
.reset-button-color .v-btn__content {
    color: unset;
}
</style>
